import React from 'react';
import { SideBarItems } from 'components/Sidebar';
import { GroupOutlined, BusinessOutlined, DescriptionOutlined, CardMembershipOutlined, LanguageOutlined, ConfirmationNumberOutlined, QueueOutlined, NotificationsOutlined } from '@mui/icons-material';
import { WorkspacesOutlined } from '@mui/icons-material';
import { LockKeyhole } from 'lucide-react';
import { Users, Companies, WorkerPool, Moderation, SystemTemplates, BusinessPlans, Domains, SupportTickets, SystemQueue, SystemNotifications } from 'modules/Administration';

export const ModulesMenu: SideBarItems[] = [{
  path: "/",
  urlKey: "administration",
  text: "Administration",
  icon: <LockKeyhole />,
  type: "menuHeader",
  menuKey: "campaignKing",
  requiredRole: "superAdmin",
  dictionaryKey: "sidebar-menu-administration",
  items: [
    {
      path: "/administration/",
      urlKey: "users",
      text: "Users",
      icon: <GroupOutlined />,
      type: "menuItem",
      menuKey: "campaignKing",
      module: <Users />,
      requiredRole: "superAdmin",
      dictionaryKey: "sidebar-menu-administration-users",
    },
    {
      path: "/administration/",
      urlKey: "companies",
      text: "Companies",
      icon: <BusinessOutlined />,
      type: "menuItem",
      menuKey: "campaignKing",
      module: <Companies />,
      requiredRole: "superAdmin",
      dictionaryKey: "sidebar-menu-administration-companies",
    },
    {
      path: "/administration/",
      urlKey: "system-templates",
      text: "System Templates",
      icon: <DescriptionOutlined />,
      type: "menuItem",
      menuKey: "campaignKing",
      module: <SystemTemplates />,
      requiredRole: "superAdmin",
      dictionaryKey: "sidebar-menu-administration-system-templates",
    },
    {
      path: "/administration/",
      urlKey: "system-notifications",
      text: "System Notifications",
      icon: <NotificationsOutlined />,
      type: "menuItem",
      menuKey: "campaignKing",
      module: <SystemNotifications />,
      requiredRole: "superAdmin",
      dictionaryKey: "sidebar-menu-administration-system-notifications",
    },
    // {
    //   path: "/administration/",
    //   urlKey: "openai",
    //   text: "OpenAI",
    //   icon: <LockKeyhole />,
    //   type: "menuItem",
    //   menuKey: "campaignKing",
    //   module: <OpenAI />,
    //   requiredRole: "superAdmin",
    //   dictionaryKey: "sidebar-menu-administration-openai",
    // },
    {
      path: "/administration/",
      urlKey: "worker-pool",
      text: "Worker Pool",
      icon: <WorkspacesOutlined />,
      type: "menuItem",
      menuKey: "campaignKing",
      module: <WorkerPool />,
      requiredRole: "superAdmin",
      dictionaryKey: "sidebar-menu-administration-worker-pool",
    },
    {
      path: "/administration/",
      urlKey: "system-queue",
      text: "System Queue",
      icon: <QueueOutlined />,
      type: "menuItem",
      menuKey: "campaignKing",
      module: <SystemQueue />,
      requiredRole: "superAdmin",
      dictionaryKey: "sidebar-menu-administration-system-queue",
    },
    // {
    //   path: "/administration/",
    //   urlKey: "gsm-worker-pool",
    //   text: "GSM Worker Pool",
    //   icon: <RouterOutlined />,
    //   type: "menuItem",
    //   menuKey: "campaignKing",
    //   module: <GSMWorkerPool />,
    //   requiredRole: "superAdmin",
    //   dictionaryKey: "sidebar-menu-administration-gsm-worker-pool",
    // },
    {
      path: "/administration/",
      urlKey: "moderation",
      text: "Moderation",
      icon: <LockKeyhole />,
      type: "menuItem",
      menuKey: "campaignKing",
      module: <Moderation />,
      requiredRole: "superAdmin",
      dictionaryKey: "sidebar-menu-administration-moderation",
    },
    {
      path: "/administration/",
      urlKey: "business-plans",
      text: "Business Plans",
      icon: <CardMembershipOutlined />,
      type: "menuItem",
      menuKey: "campaignKing",
      module: <BusinessPlans />,
      requiredRole: "superAdmin",
      dictionaryKey: "sidebar-menu-administration-business-plans",
    },
    {
      path: "/administration/",
      urlKey: "domains",
      text: "Domains",
      icon: <LanguageOutlined />,
      type: "menuItem",
      menuKey: "campaignKing",
      module: <Domains />,
      requiredRole: "superAdmin",
      dictionaryKey: "sidebar-menu-administration-domains",
    },
    {
      path: "/administration/",
      urlKey: "support-tickets",
      text: "Support Tickets",
      icon: <ConfirmationNumberOutlined />,
      type: "menuItem",
      menuKey: "campaignKing",
      module: <SupportTickets />,
      requiredRole: "superAdmin",
      dictionaryKey: "sidebar-menu-administration-support-tickets",
    },
  ]
},

{
  path: "/",
  urlKey: "administration",
  text: "Administration",
  icon: <LockKeyhole />,
  type: "menuHeader",
  menuKey: "instantUpdate",
  requiredRole: "superAdmin",
  dictionaryKey: "sidebar-menu-administration",
  items: [
    {
      path: "/administration/",
      urlKey: "users",
      text: "Users",
      icon: <GroupOutlined />,
      type: "menuItem",
      menuKey: "instantUpdate",
      module: <Users />,
      requiredRole: "superAdmin",
      dictionaryKey: "sidebar-menu-administration-users",
    },
    {
      path: "/administration/",
      urlKey: "companies",
      text: "Companies",
      icon: <BusinessOutlined />,
      type: "menuItem",
      menuKey: "instantUpdate",
      module: <Companies />,
      requiredRole: "superAdmin",
      dictionaryKey: "sidebar-menu-administration-companies",
    },
    {
      path: "/administration/",
      urlKey: "system-templates",
      text: "System Templates",
      icon: <DescriptionOutlined />,
      type: "menuItem",
      menuKey: "instantUpdate",
      module: <SystemTemplates />,
      requiredRole: "superAdmin",
      dictionaryKey: "sidebar-menu-administration-system-templates",
    },
    {
      path: "/administration/",
      urlKey: "system-notifications",
      text: "System Notifications",
      icon: <NotificationsOutlined />,
      type: "menuItem",
      menuKey: "instantUpdate",
      module: <SystemNotifications />,
      requiredRole: "superAdmin",
      dictionaryKey: "sidebar-menu-administration-system-notifications",
    },
    // {
    //   path: "/administration/",
    //   urlKey: "openai",
    //   text: "OpenAI",
    //   icon: <LockKeyhole />,
    //   type: "menuItem",
    //   menuKey: "instantUpdate",
    //   module: <OpenAI />,
    //   requiredRole: "superAdmin",
    //   dictionaryKey: "sidebar-menu-administration-openai",
    // },
    {
      path: "/administration/",
      urlKey: "worker-pool",
      text: "Worker Pool",
      icon: <WorkspacesOutlined />,
      type: "menuItem",
      menuKey: "instantUpdate",
      module: <WorkerPool />,
      requiredRole: "superAdmin",
      dictionaryKey: "sidebar-menu-administration-worker-pool",
    },
    {
      path: "/administration/",
      urlKey: "system-queue",
      text: "System Queue",
      icon: <QueueOutlined />,
      type: "menuItem",
      menuKey: "instantUpdate",
      module: <SystemQueue />,
      requiredRole: "superAdmin",
      dictionaryKey: "sidebar-menu-administration-system-queue",
    },
    // {
    //   path: "/administration/",
    //   urlKey: "gsm-worker-pool",
    //   text: "GSM Worker Pool",
    //   icon: <RouterOutlined />,
    //   type: "menuItem",
    //   menuKey: "instantUpdate",
    //   module: <GSMWorkerPool />,
    //   requiredRole: "superAdmin",
    //   dictionaryKey: "sidebar-menu-administration-gsm-worker-pool",
    // },
    {
      path: "/administration/",
      urlKey: "moderation",
      text: "Moderation",
      icon: <LockKeyhole />,
      type: "menuItem",
      menuKey: "instantUpdate",
      module: <Moderation />,
      requiredRole: "superAdmin",
      dictionaryKey: "sidebar-menu-administration-moderation",
    },
    {
      path: "/administration/",
      urlKey: "business-plans",
      text: "Business Plans",
      icon: <CardMembershipOutlined />,
      type: "menuItem",
      menuKey: "instantUpdate",
      module: <BusinessPlans />,
      requiredRole: "superAdmin",
      dictionaryKey: "sidebar-menu-administration-business-plans",
    },
    {
      path: "/administration/",
      urlKey: "domains",
      text: "Domains",
      icon: <LanguageOutlined />,
      type: "menuItem",
      menuKey: "instantUpdate",
      module: <Domains />,
      requiredRole: "superAdmin",
      dictionaryKey: "sidebar-menu-administration-domains",
    },
    {
      path: "/administration/",
      urlKey: "support-tickets",
      text: "Support Tickets",
      icon: <ConfirmationNumberOutlined />,
      type: "menuItem",
      menuKey: "instantUpdate",
      module: <SupportTickets />,
      requiredRole: "superAdmin",
      dictionaryKey: "sidebar-menu-administration-support-tickets",
    },
  ]
}
];


